import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  ProjectList,
  ProjectsList
} from 'imports/ComponentsImports';

import {
  Stepper,
  CountdownTimer,
} from 'imports/DesignImports';

import {
  CircularProgress,
  Divider
} from 'material-ui';

const styles = {
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    marginLeft: '10px'
  },
  stepperContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '2px #F0F0EF solid',
    marginBottom: '5px',
    fontFamily: 'Lato'
  },
  informationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0px 20px 0px'
  },
  addProjectButton: {
    border: '2px #212F55 solid',
    fontFamily: 'Lato',
  }
}

class ConsultantView extends Component {
  constructor(props){
    super(props);
    this.state = {
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      error: false,
      loading: true,
    }
  }

  componentDidMount(){
    this.getProjects();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los proyectos. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }

    return (
      <div style={styles.pageContainer}>
        <h1 style={styles.header}> Portafolio de Proyectos </h1>
        <Divider style={{margin: '15px'}}/>
        <div style={styles.informationContainer}>
          <div style={styles.informationText}>
            Estos son los proyectos del portafolio de innovación para medir i3.
          </div>
        </div>
        {this.state.projects.length > 0 && (
          <ProjectList
            history={this.props.history}
            projects={this.state.projects}
            apiToken={this.state.token}
            shownData={["name", "area", "leader", "edit"]}/>
        )}
      </div>
    );
  }

  getProjects = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.projectFullInformation)
      .then((response) => {
        this.setState({
          projects: response.data.filter((project) => {return project.state.length > 0 && project.state[0].state === "En desarrollo" || project.state[0].state === "No trazable" || project.state[0].state === "En proceso de firma" || project.state[0].state === "Ficha aprobada" || project.state[0].state === "Finalizado"}),
          loading: false,
          error:false
        })
      })
      .catch((error) => {
        console.log(error);
        this.setState({ error: true, loading: false })
      });
  }
}

export default withCookies(withRouter(ConsultantView));



// WEBPACK FOOTER //
// ./src/views/consultant/ConsultantView.js